import { render, staticRenderFns } from "./submission.vue?vue&type=template&id=6460101c&"
import script from "./submission.vue?vue&type=script&lang=js&"
export * from "./submission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports